import { VFC } from "react";

import ColorTag from "../../../components/ColorTag";
import { getReturnedSupportsTourOrderStatusTagColor } from "../../../helpers";
import { returnedSupportsTourOrderStatusMap } from "../../../i18n/tourOrders";
import { TourOrder } from "../../../queries/api/types";

interface ReturnedSupportStatusTagProps {
    tourOrder: TourOrder;
}

const ReturnedSupportStatusTag: VFC<ReturnedSupportStatusTagProps> = ({ tourOrder }) => {
    return (
        <ColorTag color={getReturnedSupportsTourOrderStatusTagColor(tourOrder)}>
            {returnedSupportsTourOrderStatusMap.get(tourOrder.status)}
        </ColorTag>
    );
};

export default ReturnedSupportStatusTag;
